import EmailCapture from './EmailCapture'

export default EmailCapture
// eslint-disable-next-line import/export
export * from './EmailCapture'
